import { render, staticRenderFns } from "./docline-form-dialogAPKate.vue?vue&type=template&id=a84fc064"
import script from "./docline-form-dialogAPKate.vue?vue&type=script&lang=js"
export * from "./docline-form-dialogAPKate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports